import { isLatinoChannel } from './common/latino-app';
import Constants from '@/constants/const';
// footer是否显示 about、download、media
export const footerControl = () => {
  if (isLatinoChannel()) {
    return false;
  } else {
    return true;
  }
};

// footer 是否显示seo相关模块, sitemap、ethnic storefront、location
export const footerSeoControl = () => {
  return true;
};

// 根据渠道控制分享支持的语言
export const shareSupportLanguagesControl = () => {
  if (isLatinoChannel()) {
    return Constants.LATINO_SHARE_LANUAGES;
  } else {
    return Constants.SHARE_LANUAGES;
  }
};

// 根据渠道控制review模块是否展示
export const reviewControl = () => {
  if (isLatinoChannel()) {
    return false;
  } else {
    return true;
  }
};

// 根据渠道控制是否展示下载描述模块
export const downloadDescriptionControl = () => {
  if (isLatinoChannel()) {
    return false;
  } else {
    return true;
  }
};
